// Small shared helpers for the admin catalog UI.

// Find the active pricing rule whose target is the product itself (not one of
// its options). Returns null when none. Callers read `rule_type` for strategy
// and `payload` for tiers/amount.
export const findProductRule = (pricing, productId) => (
  pricing.find((r) => r.product_id === productId && r.product_option_id == null) ?? null
);

// Find the active pricing rule for a single product option. Returns null.
export const findOptionRule = (pricing, optionId) => (
  pricing.find((r) => r.product_option_id === optionId) ?? null
);

// Find the active tiered-pricing rule's tiers for a product (a rule whose
// target is the product itself, not one of its options). Returns null when none.
export const findProductTiers = (pricing, productId) => (
  findProductRule(pricing, productId)?.payload?.tiers ?? null
);

// Find the active tiered-pricing rule's tiers for a single product option.
export const findOptionTiers = (pricing, optionId) => (
  findOptionRule(pricing, optionId)?.payload?.tiers ?? null
);

// Scope options to a product and sort them the way the server returns rows
// (display_order then name). Callers decide whether to filter inactive ones.
export const optionsForProduct = (options, productId) => options
  .filter((o) => o.product_id === productId)
  .sort((a, b) => (a.display_order - b.display_order) || a.name.localeCompare(b.name));
